export default __webpack_public_path__ + "static/media/ante-logo-wordmark.b5822fb7.svg";